import { Component, Host, h, Element } from '@stencil/core';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

@Component({
  tag: 'lgr-slider',
  styleUrl: 'slider.scss',
  shadow: false,
})
export class Slider {
  @Element() el!: HTMLLgrSliderElement;

  private swiper: Swiper | any;

  componentDidLoad() {
    const slidesLength = this.el.querySelectorAll("lgr-slide").length;
    
    this.swiper;
    this.swiper = new Swiper('.swiper', {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      loop: slidesLength > 1 ? true : false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
    });
  }

  render() {
    return (
      <Host class="swiper">
        <div class="swiper-wrapper">
          <slot />
        </div>
        <div class="swiper-pagination"></div>
      </Host>
    );
  }
}
